import { render, staticRenderFns } from "./index-v3.vue?vue&type=template&id=05004846&scoped=true&"
import script from "./index-v3.vue?vue&type=script&lang=js&"
export * from "./index-v3.vue?vue&type=script&lang=js&"
import style0 from "./index-v3.vue?vue&type=style&index=0&lang=css&"
import style1 from "./index-v3.vue?vue&type=style&index=1&id=05004846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05004846",
  null
  
)

export default component.exports